export default {
  title: 'Reply with Voice Message',
  customMessage: 'Custom message',
  customMessagePlaceholder: 'Type a custom message',
} as const;
